import { el, setChildren, mount, unmount } from 'redom';
import { createPopper } from '@popperjs/core';

const globalState = {
  delay: 200,
  tooltipsContainer: null,
  active: false,
  futureCallReferences: {
    display: null,
    hide: null
  }
};

class Tooltip {

  constructor(configuration) {

    this.content = this.buildTooltipContent(configuration.content);
    this.target = configuration.target;
    this.placement = configuration.placement || 'bottom';
    this.offset = configuration.offset || 0;

    this.target.addEventListener('mouseenter', this.handleMouseEnterEvent.bind(this));
    this.target.addEventListener('mouseleave', this.handleMouseLeaveEvent.bind(this));
    this.target.classList.add('ht-tooltip-target');

    this.el = el('.ht-tooltip-main', [this.content]);

  }

  destroy() {
    this.target.classList.remove('ht-tooltip-target');
  }

  buildTooltipContent(content) {

    if (typeof content === 'string') {
      return el('label', content);
    }

    return content;

  }

  getTooltipsContainer() {

    if (globalState.tooltipsContainer === null) {
      globalState.tooltipsContainer = el('#tooltips-container');
      mount(document.body, globalState.tooltipsContainer);
    }

    return globalState.tooltipsContainer;

  }

  displayTooltip() {

    globalState.active = true;

    createPopper(this.target, this.el, {
      placement: this.placement,
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, this.offset]
        }
      }]
    });

    setChildren(this.getTooltipsContainer(), [this.el]);

  }

  hideTooltip() {

    globalState.active = false;

    unmount(this.getTooltipsContainer(), this.el);

  }

  handleMouseEnterEvent() {

    if (globalState.active === true) {
      clearInterval(globalState.futureCallReferences.hide);
      this.displayTooltip();
    } else {
      globalState.futureCallReferences.display = setTimeout(this.displayTooltip.bind(this), globalState.delay);
    }

  }

  handleMouseLeaveEvent() {

    globalState.futureCallReferences.hide = setTimeout(this.hideTooltip.bind(this), globalState.delay);

  }

}

export default Tooltip;